import PropTypes from 'prop-types';

export const BillingPlanPropType = PropTypes.shape({
  billingPlanId: PropTypes.string,
  name: PropTypes.string,
  code: PropTypes.string,
  isCurrentPlanInSellerPlanProfile: PropTypes.bool,
  pricePerPeriod: PropTypes.shape({
    // [Deprecated] - prefer code over pricingCode
    pricingCode: PropTypes.string,
    value: PropTypes.number,
    code: PropTypes.string,
  }),
  description: PropTypes.string,
  userLimit: PropTypes.shape({
    isUnlimited: PropTypes.bool,
    limit: PropTypes.number,
    limitCode: PropTypes.string,
  }),
  shipmentLimit: PropTypes.shape({
    isUnlimited: PropTypes.bool,
    limit: PropTypes.number,
    limitCode: PropTypes.string,
  }),
  hasChatSupport: PropTypes.bool,
  hasPhoneSupport: PropTypes.bool,
  hasBranding: PropTypes.bool,
  hasSecurity: PropTypes.bool,
  isSelfManaged: PropTypes.bool,
  stampsPlanCode: PropTypes.string,
  squarePlanCode: PropTypes.string,
  apiCode: PropTypes.string,
  hasShipEngineAccess: PropTypes.bool,
  currencyType: PropTypes.string,
});

/**
 * @typedef {object} BillingPlanPricingType
 * @property {string} pricingCode - Deprecated. Prefer using code instead.
 * @property {string} value
 * @property {string} code
 */

/**
 * @typedef {object} BillingPlanLimitType
 * @property {boolean} isUnlimited
 * @property {number} limit
 * @property {string} limitCode
 */

/**
 * @typedef {object} BillingInfoPropType
 * @property {string} billingPlanId
 * @property {string} name
 * @property {string} code
 * @property {boolean} isCurrentPlanInSellerPlanProfile
 * @property {BillingPlanPricingType} pricePerPeriod
 * @property {string} description
 * @property {BillingPlanLimitType} userLimit
 * @property {BillingPlanLimitType} shipmentLimit
 * @property {boolean} hasChatSupport
 * @property {boolean} hasPhoneSupport
 * @property {boolean} hasBranding
 * @property {boolean} hasSecurity
 * @property {boolean} isSelfManaged
 * @property {string} stampsPlanCode
 * @property {string} squarePlanCode
 * @property {string} apiCode
 * @property {boolean} hasShipEngineAccess
 * @property {string} currencyType
 */
